import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient, HttpMethod } from '@hub-la/fe-core-http-client';
import { injectable, inject } from 'inversify';
import isNil from 'lodash/isNil';
import { Envs } from '../envs.js';

let GetFlags = class GetFlags {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute() {
    return __awaiter(this, void 0, void 0, function* () {
      const response = yield this.httpClient.request({
        url: `${Envs.FUNCTIONS_URL}/featureFlag/getAll/pt`,
        method: HttpMethod.POST,
        body: {
          data: null
        }
      });
      if (isNil(response.data)) {
        return [];
      }
      return this.parseValues(response.data);
    });
  }
  parseValues(data) {
    const flagsAsJSON = Object.values(data.result).map(({
      defaultValue
    }) => {
      try {
        return JSON.parse(defaultValue.value);
      } catch (error) {
        return {};
      }
    });
    return flagsAsJSON;
  }
};
GetFlags = __decorate([injectable(), __param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], GetFlags);

export { GetFlags };
